(() => {

	const $scope = $('.become-dealer-fixed')
	if( $scope.length < 1 ) return;
	$scope.find('[data-action="toggleView"]').click(function(){
		const $this = $(this);
		if( $this.hasClass('close') ){
			$this.closest('.pointer-event').hide()
				.prev().show();
		} else {
			$this.hide()
				.next().show();
		}
	});
})();
